import { InfoIcon, TextInputField } from './fields';
import { useClientFormMeta } from './clientFormMeta';
import { administratorPopover, EDIT_LOCKED_FIELDS, FIELD_LABELS, FIELD_PLACEHOLDERS, PHONE_MAX_DIGITS, STEP_HEADINGS } from './constants';
import type { ClientFormValues } from '../../../../types/ClientManagementTypes';
import styles from './ClientFormModal.module.scss';

const ClientInfoStep = () => {
  const { isEditing } = useClientFormMeta();
  const isLocked = (field: keyof ClientFormValues) => isEditing && EDIT_LOCKED_FIELDS.has(field);

  return (
    <section className={styles.step}>
      <h3 className={styles.stepHeading}>{STEP_HEADINGS.CLIENT_INFORMATION}</h3>
      <TextInputField name="name" label={FIELD_LABELS.CLIENT_NAME} placeholder={FIELD_PLACEHOLDERS.CLIENT_NAME} disabled={isLocked('name')} />

      <h3 className={styles.sectionHeading}>
        {STEP_HEADINGS.CLIENT_ADMINISTRATOR}
        <InfoIcon content={administratorPopover} />
      </h3>
      <TextInputField name="adminName" label={FIELD_LABELS.ADMIN_NAME} placeholder={FIELD_PLACEHOLDERS.ADMIN_NAME} disabled={isLocked('adminName')} />
      <TextInputField
        name="adminEmail"
        label={FIELD_LABELS.ADMIN_EMAIL}
        placeholder={FIELD_PLACEHOLDERS.ADMIN_EMAIL}
        disabled={isLocked('adminEmail')}
      />
      <TextInputField
        name="adminPhone"
        label={FIELD_LABELS.ADMIN_PHONE}
        placeholder={FIELD_PLACEHOLDERS.ADMIN_PHONE}
        disabled={isLocked('adminPhone')}
        maxLength={PHONE_MAX_DIGITS}
        digitsOnly
      />
    </section>
  );
};

export default ClientInfoStep;
